<template>
  <div>
    <p v-for="(item, index) in recordings" :key="index">
    <!-- 战斗打架输出的日志 -->
      <span v-if="item.type == 'combat'">
        <tag v-if="!isActive">〖第{{index+1}}回合〗</tag>
        <tag color="#373e57"  v-if="isActive">〖第{{index+1}}回合〗</tag>
<!--       :color="item.isSkill!=1  ? 'default' : 'primary' " -->
        <span :style="{
            color: item.identity == 0 ? 'green' : '#6e44c0',
          }"
        >
          {{ item.attacker }}
        </span>
        攻击了
        <span style="color: red">{{ item.hinjured }}</span>
        <span v-if="item.isSkill != 1">
          造成了
          <span
          >
            {{ item.hurt }}   点<span v-if="item.attElement!=='无'"
                                     :style="{ color: distinguishColor(item.attElement) }">『{{ item.attElement }}属性』</span>
            <span v-if="item.attElement==='无'"> 『{{ item.hurtType === 1 ? '力道': '灵力' }}』</span>
            <span v-if="item.isCritical == 1"  style="color: #fa7c1cd9" >暴击</span>伤害
          </span>
        </span>
        <span v-else>
          用 <span style="color: #2f90b9 ">『{{ item.skillName }}』</span>造成了
          <span >
            {{ item.hurt }}  点<span v-if="item.attElement!=='无'" :style="{ color: distinguishColor(item.attElement) }"> 『{{ item.attElement }}属性』</span>
            <span v-if="item.attElement==='无'" :style="{ color: distinguishColor(item.hurtType) }"> 『{{ item.hurtType === 1 ? '力道': '灵力' }}』</span>
            <span v-if="item.isCritical == 1"  style="color: #fa7c1cd9" >暴击</span>伤害
          </span>
        </span>
        <span
          v-if="item.isCritical == 2"
          :style="{
            color: '#19956f',
          }"
        >
          [闪避了]
        </span>
         <span
           v-if="item.isCritical == 3"
           :style="{
            color: '#19956f',
          }"
         >
          [未命中]
        </span>
        <span   v-if="item.isCritical != 2 && item.isCritical != 3">
          剩余
          <span style="color: red">{{ item.surplusHealth }}</span>
          血量,
          <span style="color: green">{{ item.surplusShieldValue || '0' }}</span>
          护盾
        </span>
        <span v-if="item.isCombo == 1" style="color: #1f838499">
           [触发连击]
        </span>
        <!-- 持续伤害展示的地方 -->
        <template v-if="item.hinjuredConmbatList">
          <p
            v-for="(continued, idx) in item.hinjuredConmbatList"
            :key="idx"
          >
          <span  v-if="continued.hurtType == 10" style="color: #9c9c90" >
            受到了  <span style="color: #d3adf7"> {{ continued.skillName }}</span> : {{ continued.skillDesc }}
          </span>
          <span v-if="continued.hurtType != 10" >
              <span>{{ continued.attacker }}</span>
             <span v-if="continued.hurtType == 4" style="color: #8b78e6">
                [触发反击]
             </span>
            <span  v-if="continued.skillName">
               使用 <span style="color: #0090ffe0">{{ continued.skillName }}</span>
            </span>
            <span v-if="continued.hurtType != 9"
                  :style="{
                              color: 'rgb(6 0 255)',
                              // fontSize: continued.isCritical == 0 ? '14px' : '20px',
                            }"
            >
                          造成了  {{ continued.hurt }} 点<span v-if="continued.attElement!=='无'"> {{ continued.attElement }}属性伤害 </span>
            </span>
            <span v-if="continued.hurtType == 9"
                  :style="{
                              color: '#19be6b',
                              // fontSize: continued.isCritical == 0 ? '14px' : '20px',
                            }"
            >
                           治疗 {{ continued.hinjured }} {{ continued.hurt }} 点血量
                          </span>
            剩余
            <span style="color: red">
                            {{ continued.surplusHealth }}
                          </span>
            血量
           </span>
          </p>
        </template>
      </span>
      <!-- 战斗恢复的地方 -->
      <span v-if="item.type == 'gain'">
        <tag  color="success">〖第{{index+1}}回合〗</tag>
        <span
          :style="{
            color: item.identity == 0 ? '#19be6b' : '#19be6b',
          }"
        >
          {{ item.attacker }}
        </span>
        <span>
          使用治愈技能 『{{ item.skillName }}』
          帮
          <span>{{ item.hinjured }}</span>
          回复
          <span :style="{ color: '#19be6b' }">
            {{ item.hurt }} 点血量
          </span>
        </span>
        剩余
        <span style="color: red">{{ item.surplusHealth }}</span>
        血量 ，
        溢出
        <span style="color: red">{{ item.surplusShieldValue }}</span>
        护盾
      </span>
      <!-- 战斗失败或成功输出的地方 -->
      <span
        style="font-size: 15px;color:gray"
        v-if="item.type == 'result'"
      >
        〖{{ item.result }}〗 剩余血量:{{ item.reHealth }} 剩余蓝量:
        {{ item.reMana }} {{ item.exp }} {{ item.goods }}
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "battleProcess",
  props: ["recordings"],
  data() {
    return {
      isActive:false, // 切换主体
    };
  },
  created() {
    const theme = window.localStorage.getItem("isTheme");
    if(theme === "black"){
      this.isActive=true;
    }else{
      this.isActive=false;
    }
  },
  watch: {
    recordings(newValue, oldValue) {
        this.recordings = newValue
    }
  },
  methods: {
    // 返回品质颜色
    distinguishColor(color) {
      if (color === "金") {
        return "#d88228";
      } else if (color === '木') {
        return "#04ad80e0";
      } else if (color === '水') {
        return "#0090ffe0";
      } else if (color === '火') {
        return "#9e0e42e0";
      } else if (color === '土') {
        return "#473602e0";
      } else if (color === '风') {
        return "#0fb479e0";
      } else if (color === '冰') {
        return "#078599e0";
      } else if (color === '雷') {
        return "#6a09f6e0";
      }
    },

  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/battleProcess.vue